'use strict';

const dialog = require('../dialog');

const elements = {
    form: $('#jobs'),
    cities: $('.jobs-cities ul'),
    results: $('.jobs-results'),
};

/**
 * Creates a job div element
 * @param  {Object} option Job object
 * @return {String} the html content
 */
function createJobDiv(option){
    return '<div class="job">' +
        '<h2 class="h3">' + option.name + '</h2>' +
        '<p>' +
            option.shortdesc + ' - ' + option.city +
        '</p>' +
        '<a href="' + option.url + '" >' + option.text + '</a>' +
    '</div>';
}

/**
 * Re-creates city and job opening list based on request data
 * Displays no result text on 0 openings or error
 * @param  {Object} data JSON reprsentation of openings
 */
function updateDom(data){
    // first clear the results
    elements.results.empty();

    // if something went wrong, clear the results and cities list
    if (!data.success){
        elements.cities.empty();
        elements.results.append('<span class="jobs-noresult">' + data.message + '</span>');
        return;
    } else {
        // update both the city list and the job results
        const openings = data.openings || [];

        // on country change update the city list and populate openings
        if (data.cities && data.cities.length > 0){
            // save all openings list element
            const $first = elements.cities.find('li.first');
            let count = 0;
            elements.cities.empty();

            data.cities.forEach(function(city){
                count += parseInt(city.count);

                elements.cities.append('<li>' +
                    '<a data-folder="' + city.folderID + '">' +
                        city.displayName +
                        ' <span>( ' + city.count + ' )</span> ' +
                        '</a>' +
                '</li>');

                city.openings.forEach(function(opening){
                    openings.push(opening);
                });
            });

            // set new see all openings element

            $first.find('a').data('folder',elements.form.find('#jobs-country').val());
            $first.find('a span').text('( ' + count + ' )');

            elements.cities.prepend($first);
        }

        if (openings && openings.length > 0){
            openings.forEach(function(option){
                elements.results.append(createJobDiv(option));
            });
        } else {
            elements.cities.empty();
            elements.results.append('<span class="jobs-noresult">' + data.message + '</span>');
        }
    }
}

/**
 * Filters the job data based on key an value
 * @param  {String} key   Country | City
 * @param  {Srtring} value Folder ID
 */
function filter(key, value){
    const data = {};
    data[key] = value;

    $.ajax({
        url: elements.form.attr('action'),
        method: 'GET',
        dataType: 'json',
        data : data
    }).done(function (data) {
        updateDom(data);
    });
}

function openDialog(){
    const $applicationDialog = $('.job-application-dialog');
    if ($applicationDialog.length !== 0){
        // set the form country
        $('.job-application-form form')
            .find('#jobCountry')
            .val(elements.form.find('#jobs-country').val());

        dialog.open({
            target: $applicationDialog,
            options: {
                closeOnEscape: false,
                dialogClass: 'no-close'
            }
        });
    }
}

exports.init = function () {
    elements.form.on('change', '#jobs-country', function(){
        filter('country', $(this).val());
    });

    elements.cities.on('click', 'li.first a', function(){
        elements.form.find('#jobs-country').trigger('change');
    });

    elements.cities.on('click', 'li:not(.first) a', function(){
        filter('city', $(this).data('folder'));
    });

    // open application dialog
    $('.jobs-open-application-form').on('click', 'a', function(){
        openDialog();
    });

    // open application dialog on error
    if ($('.job-application-dialog .job-application-form .confirmation-message').length !== 0){
        openDialog();
    }
};
